import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VWidget',{attrs:{"content-class":"pa-0"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('labels.broker')))]},proxy:true},{key:"content",fn:function(){return [_c(VList,{staticClass:"mb-1"},[_c(VListItem,{staticClass:"py-1"},[_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t('noBroker')))])],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }